import React, { useState, useEffect, useRef } from 'react';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';
import 'bootstrap/dist/css/bootstrap.min.css';

const Superposition = ({ path1, path2, sliderPosition = 0.5, onPositionChange }) => {

  const [desiredHeight, setDesiredHeight] = useState(window.innerHeight);
  const compareRef = useRef(null);

  // console.log('path1:', path1);
  // console.log('path2:', path2);

  useEffect(() => {
    const handleResize = () => setDesiredHeight(window.innerHeight);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!path1 || !path2) return <p>Images manquantes</p>;

  return (
    <div className="superposition-container container-fluid d-flex justify-content-center">
      <div className="image-compare-container col-12 col-md-6 p-0" ref={compareRef}>
        <ReactCompareSlider
          itemOne={<ReactCompareSliderImage src={path1} alt="Left" crossOrigin="anonymous" style={{
            maxWidth: '600px',
            maxHeight: '600px',
            objectFit: 'contain',
          }} />}
          itemTwo={<ReactCompareSliderImage src={path2} alt="Right" crossOrigin="anonymous" style={{
            maxWidth: '600px',
            maxHeight: '600px',
            objectFit: 'contain',
          }} />}
          position={sliderPosition}
          onPositionChange={onPositionChange}
          style={{
            width: '100%',
            maxWidth: '600px',
            maxHeight: '600px',
          }}

  // handle={
  //   <div
  //     style={{
  //       width: '30px',           // bouton plus petit
  //       height: '30px',
  //       background: 'rgba(255,255,255,0.1)', // plus transparent
  //       border: '1px solid #16e416ff',
  //       borderRadius: '50%',
  //       display: 'flex',
  //       alignItems: 'center',
  //       justifyContent: 'center',
  //       cursor: 'pointer',
  //       boxShadow: '0 2px 6px rgba(0,0,0,0.10)',
  //       pointerEvents: 'auto',
  //     }}
  //   />
  // }  
        />
      </div>
    </div>
  );
};

export default Superposition;
